// Storage mode: 'local' = disk, 'cloud' = database
let storageMode: 'local' | 'cloud' = 'local'
const listeners: (() => void)[] = []

export function getStorageMode(): 'local' | 'cloud' { return storageMode }
export function isCloudMode(): boolean { return storageMode === 'cloud' }
export function isLocalMode(): boolean { return storageMode === 'local' }

export function toggleStorageMode() {
  storageMode = storageMode === 'local' ? 'cloud' : 'local'
  listeners.forEach(l => l())
}

export function onStorageModeChange(fn: () => void) {
  listeners.push(fn)
  return () => { const i = listeners.indexOf(fn); if (i >= 0) listeners.splice(i, 1) }
}
